import { createFileRoute } from '@tanstack/react-router'

import { ChecklistRunsPage } from '@/components/checklist-runs/ChecklistRunsPage'
import { parseChecklistRunsSearch } from '@/lib/checklist-runs-search'

export const Route = createFileRoute('/checklist-runs/')({
  validateSearch: (raw: Record<string, unknown>) => parseChecklistRunsSearch(raw),
  component: ChecklistRunsIndex,
})

function ChecklistRunsIndex() {
  const search = Route.useSearch()
  return <ChecklistRunsPage search={search} routePath="/checklist-runs/" />
}
